import leafReducer from './leafReducer';

export default leafReducer